import styled from "@emotion/styled";
import type { FC } from "react";
import React from "react";
import { useParams } from "react-router-dom";
import { signupHeaderHeightDesktop } from "src/constants/layout";
import CustomQuestionnaire from "src/ui/components/CustomQuestionnaire/CustomQuestionnaire";
import AppHeader from "../AppHeader/AppHeader";
import { ScrollHost } from "../SignupCustomContent/SignupCustomContent";

const StandaloneContent = styled.div`
  label: StandaloneContent;
  width: 100%;
  min-height: 100vh;
  min-height: 100svh;
  padding-top: ${signupHeaderHeightDesktop}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StandaloneHeader: FC = () => <AppHeader progress={0} />;

const StandaloneQuestionnaire: FC = () => {
  const { id = "" } = useParams<{ id: string }>();

  return (
    <ScrollHost>
      <div style={{ width: "100%" }}>
        <StandaloneHeader />
        <StandaloneContent className="wrap-center">
          <CustomQuestionnaire
            autoSkip={false}
            showThankYouStep
            resetScrollOnEachStep
            id={id}
            useRouting
          />
        </StandaloneContent>
      </div>
    </ScrollHost>
  );
};

export default StandaloneQuestionnaire;
